import { render, staticRenderFns } from "./walkInto.vue?vue&type=template&id=65b32fc2&scoped=true"
import script from "./walkInto.vue?vue&type=script&lang=js"
export * from "./walkInto.vue?vue&type=script&lang=js"
import style0 from "./walkInto.vue?vue&type=style&index=0&id=65b32fc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b32fc2",
  null
  
)

export default component.exports